import { postAdminTrialAction } from './adminTrial'

export type TrialWelcomeResult = {
  success?: boolean
  email_sent?: boolean
  whatsapp_sent?: boolean
  errors?: string[]
  error?: string
  skipped?: string
}

export type TrialWelcomePayload = {
  org_id: string
  org_name: string
  owner_name: string
  owner_email: string
  owner_phone: string
  existing_user?: boolean
}

export async function sendTrialWelcome(
  payload: TrialWelcomePayload,
): Promise<{ ok: boolean; data: TrialWelcomeResult }> {
  const res = await postAdminTrialAction('send-trial-welcome', {
    org_id: payload.org_id, owner_email: payload.owner_email, existing_user: payload.existing_user === true,
  })
  const data = (await res.json().catch(() => ({}))) as TrialWelcomeResult
  return { ok: res.ok, data }
}
